// extracted by css-extract-rspack-plugin
export default {"searchTagsWrapper":"_655250ff"};